module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DialogBox', {
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "show": _vm.initialiseDialog
    }
  }, [_c('template', {
    slot: "header"
  }, [(_vm.linkedKeys.length) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mt-1",
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }], null, false, 1793895034)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.unlinkAllFiles
    }
  }, [_c('v-list-item-title', [_vm._v("Unlink All Files")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "float": "right",
      "width": "150px"
    },
    attrs: {
      "slot": "sidebar"
    },
    slot: "sidebar"
  }, [_c('div', {
    staticClass: "grey--text",
    staticStyle: {
      "text-align": "center",
      "padding": "4px"
    }
  }, [_vm._v("\n            " + _vm._s(this.selectedKeys.length || 'None') + " selected\n            "), (this.selectedKeys.length) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectedKeys = []
      }
    }
  }, [_vm._v("Clear")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grey--text",
    staticStyle: {
      "padding": "0px 0px 5px 26px"
    }
  }, [_vm._v("\n            " + _vm._s(this.linkedKeys.length || 'None') + " linked\n            "), (this.linkedKeys.length) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectLinkedKeys($event)
      }
    }
  }, [_vm._v("Select")]) : _vm._e()]), _vm._v(" "), (this.selectedKeys.length) ? [(_vm.linkButtonVisible) ? _c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.linkSelectedFiles
    }
  }, [_vm._v("Link")]) : _vm._e(), _vm._v(" "), (_vm.selectedLinkedKeys.length) ? _c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.unlinkSelectedFiles
    }
  }, [_vm._v("Un-link")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.emailFiles
    }
  }, [_vm._v("Email")]), _c('br')] : _vm._e(), _vm._v(" "), (this.selectedKeys.length == 1) ? [_c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.renameFile
    }
  }, [_vm._v("Rename")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.copyLink
    }
  }, [_vm._v("Copy Link")])] : _vm._e(), _vm._v(" "), _c('UploadWrapper', {
    on: {
      "select": _vm.uploadFiles
    }
  }, [_c('v-btn', {
    staticClass: "mt-1  mr-1 mb-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("Upload")])], 1), _vm._v(" "), (this.selectedKeys.length > 1 && !_vm.isMobile) ? [_c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.downloadZip
    }
  }, [_vm._v("Save to Zip")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "10px",
      "padding-left": "10px",
      "min-height": "400px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "quick-input no-focus",
    staticStyle: {
      "width": "100%",
      "margin-top": "8px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.filesDisplay), function(file) {
    return _c('v-list-item', {
      key: file.key,
      staticClass: "blue-select",
      class: {
        'selected': _vm.isSelected(file.key)
      },
      attrs: {
        "title": file.title + ' (' + file.name + ')'
      },
      on: {
        "click": [function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.selectSingle(file)
        }, function($event) {
          if (!$event.metaKey) { return null; }
          return _vm.selectMulti(file)
        }, function($event) {
          if (!$event.ctrlKey) { return null; }
          return _vm.selectMulti(file)
        }, function($event) {
          if (!$event.shiftKey) { return null; }
          return _vm.selectRange(file)
        }]
      }
    }, [_c('v-list-item-avatar', [(_vm.isLinked(file.key)) ? _c('v-btn', {
      staticClass: "mt-1 primary",
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v("insert_link")])], 1) : _c('v-icon', {
      attrs: {
        "large": "",
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.fileIconString(file)))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                    " + _vm._s(_vm.getFileName(file)) + " "), _c('span', {
      staticClass: "light-text small-text"
    }, [_vm._v(_vm._s(_vm._f("shortDate")(file.stamp.date)))])]), _vm._v(" "), _c('v-list-item-subtitle', [_c('span', {
      attrs: {
        "title": file.originalName
      }
    }, [_vm._v(_vm._s(file.originalName))])])], 1), _vm._v(" "), _c('v-list-item-action', [(file.loading) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#888"
      }
    }, [_vm._v(_vm._s(file.progress) + "% ")]), _vm._v(" "), _c('v-progress-circular', {
      staticClass: "grey--text",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "size": 20,
        "width": 2,
        "indeterminate": ""
      }
    })], 1) : [_c('a', {
      ref: 'download' + file.key,
      refInFor: true,
      staticClass: "transparent",
      attrs: {
        "href": file.value,
        "target": "_blank"
      }
    }, [_c('v-btn', {
      staticClass: "mt-1 grey--text",
      attrs: {
        "icon": ""
      },
      on: {
        "xxclick": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-file-image")])], 1)], 1)]], 2)], 1)
  }), 1)], 1), _vm._v(" "), (this.selectedKeys.length) ? _c('template', {
    slot: "footer"
  }, [_c('DeleteButton', {
    on: {
      "delete": _vm.deleteSelectedFiles
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email
    },
    on: {
      "sent": function($event) {}
    }
  }), _vm._v(" "), _c('InputDialog', {
    attrs: {
      "settings": _vm.inputDialog.settings
    },
    on: {
      "save": _vm.changeFileName
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ab3a43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/FileDialog.vue
// module id = 2532
// module chunks = 1